import { FC } from 'react';
import { Container, Divider, Icon, IconName, Stack, useToken } from '@optimus-web/core';
import { DividerType } from '../types';

interface SectionDividerProps {
    dividerType?: DividerType;
}

const Line: FC = () => {
    const containerSize = useToken('sizing400');

    return (
        <Container height={`${containerSize}px`} padding={['0', '400']}>
            <Stack fill>
                <Divider direction="vertical" />
            </Stack>
        </Container>
    );
};

export const SectionDivider: FC<SectionDividerProps> = ({ dividerType = 'line' }) =>
    dividerType === 'arrow' ? (
        <Stack alignment="center">
            <Container padding="200">
                <Icon size="small" value={IconName.ArrowDown} />
            </Container>
        </Stack>
    ) : (
        <Line />
    );
